<script>
	import { Pie } from 'vue-chartjs'


	export default {
	  extends: Pie,
        data () {
            return {
                chart_options: {

                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position : "bottom"
                    },
                    title: {
                        display: true,
                        text: this.title_text
                    },
                },
                datas: {},
            }
        },
	  mounted () {

	    // Overwriting base render method with actual data.
	  },
	  methods: {
          drawPieGraph(datas_pie){
              let componentGraph = this;
              setTimeout(function (){
                  componentGraph.renderChart(datas_pie, componentGraph.chart_options)
              },1000);
          },
	  },
	  props: {
          title_text:{
              type:String,
              required:false,
              default : 'TITOLO'
          }
	  }

	}
</script>
